const STORAGE_KEY = 'ncziPatientAutoVerifyCases';

const readMarkedCases = (): string[] => {
	try {
		const stored = window.sessionStorage.getItem(STORAGE_KEY);
		const parsed = stored ? JSON.parse(stored) : [];
		return Array.isArray(parsed) ? parsed : [];
	} catch {
		return [];
	}
};

const writeMarkedCases = (caseIds: string[]) => {
	try {
		if (caseIds.length) {
			window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(caseIds));
		} else {
			window.sessionStorage.removeItem(STORAGE_KEY);
		}
	} catch {
		return;
	}
};

export const markCaseForPatientAutoVerify = (caseId: string) => {
	const marked = readMarkedCases();
	if (marked.indexOf(caseId) === -1) {
		writeMarkedCases([...marked, caseId]);
	}
};

export const consumeCaseForPatientAutoVerify = (caseId: string): boolean => {
	const marked = readMarkedCases();
	if (marked.indexOf(caseId) === -1) {
		return false;
	}

	writeMarkedCases(marked.filter(item => item !== caseId));
	return true;
};
